import { faUnlock } from "@fortawesome/free-solid-svg-icons"
import { Field, reduxForm, InjectedFormProps } from "redux-form"
import styled from "styled-components"
import { UpdateUserInput } from "../../../rpcs/dist/UserRPC"
import Color from "../../../style/enum/color"
import { IFormField, validate } from "./validation"
import React from "react"
import StyledInputField, {
  IStyledFieldProps,
} from "../../../components/parts/styled-field/styled-input-field"
import { AuthSendButton } from "../../../components/templates/auth/components/auth-send-button"

const formData: Array<
  IStyledFieldProps<keyof NonNullable<UpdateUserInput["password"]>>
> = [
  {
    name: "currentPassword",
    title: "現在のパスワード",
    icon: faUnlock,
    type: "password",
    placeholder: "現在のパスワードを入力",
    component: StyledInputField,
  },
  {
    name: "newPassword",
    title: "新しいパスワード",
    icon: faUnlock,
    type: "password",
    placeholder: "8文字以上の半角英数字",
    component: StyledInputField,
  },
  {
    name: "newPasswordForConfirmation",
    title: "新しいパスワード確認",
    icon: faUnlock,
    type: "password",
    placeholder: "新しいパスワードを再入力",
    component: StyledInputField,
  },
]

export class FormComponent extends React.Component<
  InjectedFormProps<{}, IFormField>
> {
  public render() {
    const { handleSubmit, submitting } = this.props
    return (
      <form onSubmit={handleSubmit}>
        <Caution>
          ※SNS連携でログインしているユーザーはパスワード設定できません
        </Caution>
        {formData.map((data, i) => (
          <Field key={i} {...data} />
        ))}
        <AuthSendButton
          isSending={submitting}
          text={"パスワードを更新"}
          sendingText={"パスワードを更新中です"}
          onClick={handleSubmit}
        />
      </form>
    )
  }
}

export const PasswordForm = reduxForm({
  form: "UserSettingPasswordForm",
  validate,
})(FormComponent)

const Caution = styled.div`
  font-size: 0.8rem;
  color: ${Color.DIMGRAY};
  padding: 8px 0;
`
